
export function getWorkflowURI() {
  // const baseUrl = env === 'prod' ? 'traders.ninjacart.in' : 'apiv2.trafyn.info';
  // let returnUrl = `https://${baseUrl}/workflow-engine`;
  // return returnUrl;
  return process.env.APP_WORKFLOW_URI;
}

export function getWorkflowV2URI() {
  // const baseUrl = env === 'prod' ? 'apiv2.ninjacart.in' : 'apiv2.trafyn.info';
  // let returnUrl = `https://${baseUrl}/workflow-engine`;
  // return returnUrl;
  return process.env.APP_WORKFLOW_URI_V2;
}

export function getIamURI() {
  // Now, we don't use Azure API calls.
  // const baseUrl = env === 'prod' ? 'api.ninjacart.in/iam' : 'api.trafyn.info/iam';

  // const baseUrl = env === 'prod' ? 'apiv2.ninjacart.in/iam' : 'apiv2.trafyn.info/iam';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_IAM_URI;
}

export function getKisaanBaseURL() {
  // const baseUrl = env === 'prod' ? 'apiv2.ninjacart.in' : 'nc-kisaan.trafyn.info';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_KISAN_URI;
}
export function getFeedURI() {
  // const baseUrl = env === 'prod' ? 'feeds.ninjacart.in' : 'mastodon.trafyn.info';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_FEED_URI;
}

export function getStreamURI() {
  // const baseUrl = env === 'prod' ? 'stream.ninjacart.in' : 'stream.trafyn.info';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_STREAM_URI;
}

export function getHashKey() {
  // const hashKey = env === 'prod' ? 'zdMTtJC3K8s' : 'DPUO9Zz4cS7';
  // return hashKey;
  return process.env.APP_SMS_HASH;
}
export function toolId() {
  // return t_id;
  return process.env.APP_TOOL_ID;
}
export function termsPrivacy() {
  const termsConditions = {
    termsConditionsUrl: process.env.APP_TERMS_AND_CONDITONS,
    privacyPolicyUrl: 'https://sites.google.com/view/ninja-kisan/privacy-policy',
  };
  return termsConditions;
}


// export function getDebugLog() {
//   const isDebugEnable = process.env.APP_ENABLE_EVENTS_DEBUg_LOG === 'false' ? false : true;
//   // return isDebugEnable;
//   return <boolean> (<unknown> process.env.APP_ENABLE_EVENTS_DEBUg_LOG) ?? false;
// }

export function isAzureKeyForLogin() {
  const hashKey = 'identity';
  return hashKey;
}

export function getEnvValue(): string {
  let env = process.env.ENV ?? 'dev';
  return env;
}

export function adaptiveStreamURI() {
  // const baseUrl =
  //   env === 'prod' ? 'apiv2.ninjacart.in/adaptive-hub' : 'apiv2.trafyn.info/adaptive-hub';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_ADAPTIVE_HUB_URI;
}

export function getAdaptiveHubURI() {
  // const baseUrl =
  //   env === 'prod' ? 'apiv2.ninjacart.in/adaptive-hub' : 'apiv2.trafyn.info/adaptive-hub';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_ADAPTIVE_HUB_URI;
}

export function getQnAURI() {
  // const baseUrl = env === 'prod' ? 'apiv2.ninjacart.in/qna' : 'apiv2.trafyn.info/qna';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_QNA_URI;
}

export function getQnANewURI() {
  return process.env.APP_QNA_NEW_URI;
}

export function geteventsApi() {
  // const eventUrl =
  //   env === 'prod'
  //     ? 'kisan.events.datalake.input.topic/messages'
  //     : 'qa.kisan.events.datalake.input.topic/messages';
  // return eventUrl;
  return process.env.APP_LAKEHOUSE_TOPIC;
}

// function getUserValue() {
//   const userId = useProfileStore?.getState().userProfile?.user?.id;
//   return userId;
// }

// export function getRecommendListBasedOnUser() {
//   console.log('Get user value => ', getUserValue());
//   if (getUserValue()) {
//     return `${getStreamURI()}/api/v1/search/videos?start=0&count=25&hasHLSFiles=true&skipCount=true&nsfw=false&sort=-publishedAt&searchTarget=local&excludeAlreadyWatched=true&tagsOneOf=system_longvideo&tagsOneOf=system_${languageSelectChange()}`;
//   } else {
//     return `${getStreamURI()}/api/v1/search/videos?start=0&count=25&hasHLSFiles=true&skipCount=true&nsfw=false&sort=-publishedAt&searchTarget=local&tagsOneOf=system_longvideo&tagsOneOf=system_${languageSelectChange()}`;
//   }
// }


function getRecommendListApi(payload,deviceId) {
  let url = `${getKisaanBaseURL()}/kisaan/home/p/similar-videos/v2?offset=${payload.offset}&count=${payload.count}&videoId=${payload.videoId}&deviceId=${deviceId}`;
  if (payload.geoLatitude && payload.geoLongitude) {
    url += `&geoLatitude=${payload.geoLatitude}&geoLongitude=${payload.geoLongitude}`;
  }
  return url;
}

function getWeatherDetailApi(latitude: string, longitude: string,appLanguage,weatherDetail) {
  const lat = weatherDetail?.expectedParams?.find((ele) => ele?.toString() === 'lat');
  const lon = weatherDetail?.expectedParams?.find((ele) => ele?.toString() === 'lon');
  const lang = weatherDetail?.expectedParams?.find((ele) => ele?.toString() === 'lang');
  const language = appLanguage ?? 'hi';
  const weatherURI = `${weatherDetail?.apiLink}?${lat}=${latitude}&${lon}=${longitude}&${lang}=${language}&ver=${weatherDetail?.defaultParams[0]?.ver}`;
  return weatherURI;
}


export function getMandinewsUrl() {
  return process.env.APP_MANDINEWS_URL;
}

export function getDiscoveryMetaApi(payload) {
  let url = `${getKisaanBaseURL()}/kisaan/discovery/p/metadata?deviceIdOrUserId=${payload.deviceIdOrUserId}`;

  if (payload.geoLatitude && payload.geoLongitude) {
    url += `&geoLatitude=${payload.geoLatitude}&geoLongitude=${payload.geoLongitude}`;
  }

  return url;
}

export function getEventsBaseURL() {
  // const baseUrl = env === 'prod' ? 'apiv2.ninjacart.in' : 'nc-kisaan.trafyn.info';
  // let returnUrl = `https://${baseUrl}`;
  // return returnUrl;
  return process.env.APP_EVENTS_URL;
}


function getShortVideoV3Api(offset, count, next,latitude,longitude,userId) {
  let url = `${getKisaanBaseURL()}/kisaan/home/p/shorts/v3?offset=${offset}&count=${count}&next=${next}&isUserPersonalized=true`;
  if (latitude && longitude) {
    url += `&geoLatitude=${latitude}&geoLongitude=${longitude}`;
  }
  if (userId) {
    url += `&userId=${userId}`;
  }
  return url;
}
function getGlobalSearchApi(payload, selectedCategory) {
  console.log('payload selectedCategory *****', selectedCategory);
  let url = `${getKisaanBaseURL()}/kisaan/search/p/global?search=${payload.search}`;
  if (selectedCategory === 'all') {
    url += `&type=Qna&type=Feed&type=Stream`;
  } else if (selectedCategory === 'videos') {
    url += `&type=Stream`;
  } else if (selectedCategory === 'QNA') {
    url += `&type=Qna`;
  } else if (selectedCategory === 'Feed') {
    url += `&type=Feed`;
  }
  url += `&from=${payload?.from}&size=${payload?.size}`;

  return url;
}

const paths = {
  bootstrap: () => `${getKisaanBaseURL()}/kisaan/bootstrap/p/start`,
  login: () => `${getIamURI()}/api/v1/auth/send/otp`,
  userTimeLines: (uniqueKeys: string,appLanguage) =>
    `${getFeedURI()}/api/v1/timelines/tag/system_longvideo?all[]=system_${appLanguage}&any[]=system_image&local=true&limit=5${uniqueKeys ? '&max_id=' + uniqueKeys : ''}`,
  getThreds: (id) => `${getFeedURI()}/api/v1/statuses/${id}/context`,
  like: (id) => `${getFeedURI()}/api/v1/statuses/${id}/favourite`,
  disLike: (id) => `${getFeedURI()}/api/v1/statuses/${id}/unfavourite`,
  onboardTraders: () => `${getIamURI()}/api/v1/auth/signin/otp`,
  OTPAuth: () => `${getKisaanBaseURL()}/kisaan/auth`,
  getExchangeToken: (userid) => `${getKisaanBaseURL()}/kisaan/auth/exchangeToken/${userid}`,
  pincodeAddress: (realmId, userId) =>
    `${getWorkflowURI()}/workflow-engine/${realmId}/${userId}/v1/execution/service/run/pincode-address`,
  editProfileSubmit: (userId, realmId) => `${getKisaanBaseURL()}/kisaan/user/${userId}/${realmId}`,
  // getShortVideoPath: (uniqueKeys: string | null, limit: number = 3) =>
  //   `${getFeedURI()}/api/v1/timelines/tag/system_shortvideo?all[]=system_hi&local=true&limit=${limit}${uniqueKeys ? '&max_id=' + uniqueKeys : ''}`,
  getShortVideoPath: (offset: number, count: number, next: string | null = null,latitude:string,longitude:string,userId:string) =>
    `${getShortVideoV3Api(offset, count, next,latitude,longitude,userId)}`,
  uplodFile: (userId) => `${getKisaanBaseURL()}/kisaan/user/${userId}`,
  postContentInMastodon: () => `${getFeedURI()}/api/v1/statuses`,
  importYoutubeVideo: () => `${getStreamURI()}/api/v1/videos/imports`,
  uplodImages: () => `${getFeedURI()}/api/v2/media`,
  getFeedDetail: (id) => `${getFeedURI()}/api/v1/statuses/${id}`,
  refreshStreamToken: (token) => `${getKisaanBaseURL()}/kisaan/auth/peerTube/${token}`,
  globalSearchAPIV2: (payload, selectedCategory) =>
    `${getGlobalSearchApi(payload, selectedCategory)}`,
  eventsApi: () => `${adaptiveStreamURI()}/stream/p/events`,
  novuSubscriberApi: () => `${getKisaanBaseURL()}/kisaan/notification/p/subscriber`,
  novuSubscriberWithFCM: () =>
    `${getKisaanBaseURL()}/kisaan/notification/p/signupSubscribeWithCreds`,
  discoveryMetadata: (payload) => `${getDiscoveryMetaApi(payload)}`,
  getContinueWatchList: (payload) =>
    `${adaptiveStreamURI()}/stream/user/video/history?start=${payload?.start}&count=10&continueWatching=true`,
  playListSearchApi: (params) =>
    `${adaptiveStreamURI()}/stream/video/playlist?start=0&count=10&search=${params.search}`,
  deleteNovuSubscriberApi: (subscriberId) =>
    `${getKisaanBaseURL()}/kisaan/notification/p/subscriber/${subscriberId}`,
  getPlayBackUrl: (id) => `${getStreamURI()}/api/v1/videos/${id}`,
  getPlayBackList: (item) => `${getStreamURI()}/api/v1/videos/${item}`,
  getStreamUser: () => `${getStreamURI()}/api/v1/users/me`,
  getRecommendList: (payload,deviceId) => `${getRecommendListApi(payload,deviceId)}`,
  getPlayListItems: (id, start, count) =>
    `${getKisaanBaseURL()}/kisaan/playlist/p/videos/${id}?start=${start}&count=${count}`,
  peerTubeLikeVideo: (id) => `${getStreamURI()}/api/v1/videos/${id}/rate`,
  peerTubeGetComments: (payload) =>
    `${getStreamURI()}/api/v1/videos/${payload?.id}/comment-threads?start=${payload?.start}&count=${payload?.count}&sort=-createdAt`,
  peerTubeGetVideoRatings: (id) => `${getStreamURI()}/api/v1/users/me/videos/${id}/rating`,
  peerTubePostCommentsOnVideo: (id) => `${getStreamURI()}/api/v1/videos/${id}/comment-threads`,
  novuSubscriberFCMApi: () => `${getKisaanBaseURL()}/kisaan/notification/p/subscriber/credentials`,
  aggregatorFeedApi: (payload) =>
    `${getKisaanBaseURL()}/kisaan/home/p/feeds?offset=${payload.offset}&count=${payload.count}&next=${payload.next}`,
  updateLikeCountPeerTubeApi: (id) => `${getStreamURI()}/api/v1/users/me/videos/${id}/rating`,
  updateVideoStreamPlayback: (id: string) => `${getStreamURI()}/api/v1/videos/${id}/views`,
  // getPostDetailApi: (payload) =>
  //   `${getQnAURI()}/api/realms/${payload?.realmId}/users/${payload?.userId}/posts/${payload?.id}`,
  postQuestionPath: (payload) =>
    `${getQnAURI()}/api/realms/${payload?.realmId}/users/${payload?.userId}/posts`,
  upVoteQnA: (payload) =>
    `${getQnAURI()}/api/realms/${payload?.realmId}/users/${payload?.userId}/posts/${payload.id}/voteup`,
  downVoteQnA: (payload) =>
    `${getQnAURI()}/api/realms/${payload?.realmId}/users/${payload?.userId}/posts/${payload.id}/votedown`,
  createModerationQuestionAndFeed: (payload) =>
    `${getWorkflowV2URI()}/workflow-engine/${payload?.realmId}/${payload?.userId}/v1/execution/service/run/create-ticket-post`,
  createVideoTicket: (realmId, userId) =>
    `${getWorkflowV2URI()}/workflow-engine/${realmId}/${userId}/v1/execution/service/run/create-ticket-video`,
  // getHomePageFeedPath: () => `https://nc-kisaan.trafyn.info/kisaan/home/p/feeds`,
  getHomePageFeedPath: () => `${getKisaanBaseURL()}/kisaan/home/p/feeds`,
  getEvents: () => `https://events.ninjacart.in/utilities/events/api/v1/topics/${geteventsApi()}`,
  getStreamTokenOnExpiry: (userId: string) =>
    `${getKisaanBaseURL()}/kisaan/auth/exchangeToken/${userId}?sync=Stream`,
  getExchangeTokenUrl: (userId: string) =>
    `${getKisaanBaseURL()}/kisaan/auth/exchangeToken/${userId}`,
  getTruecallerData: () => `${getIamURI()}/api/v1/auth/social-login/truecaller`,

  getCategoryList: () => `${getKisaanBaseURL()}/kisaan/crop/p/list`,

  getCropsbyCategoryList: (cropId) =>
    `${getKisaanBaseURL()}/kisaan/crop/p/category/list?cropId=${cropId}`,

  createUserPreference: (realmId, userId) =>
    `${getKisaanBaseURL()}/kisaan/crop/preference/${userId}/${realmId}/create`,

  validateReferralCode: (referralCode) =>
    `${getKisaanBaseURL()}/kisaan/user/p/validation/${referralCode}`,
  getWeatherDetail: (lat: string, long: string,appLanguage:string,weatherDetail) => `${getWeatherDetailApi(lat, long,appLanguage,weatherDetail)}`,

  updateUserPreference: (realmId, userId) =>
    `${getKisaanBaseURL()}/kisaan/crop/preference/${userId}/${realmId}/update`,

  getCropsPreference: (userId, realmId) =>
    `${getKisaanBaseURL()}/kisaan/crop/user/preferences?userId=${userId}&realmId=${realmId}`,

  getCropMediaDetail: () => `${getKisaanBaseURL()}/kisaan/crop/detail`,
  autoSuggestSearch: (search) =>
    `${getKisaanBaseURL()}/kisaan/global/p/auto/suggester?search=${search}`,

  getContactDetails: () => `${getKisaanBaseURL()}/kisaan/user/contactMinimalInfo`,

  updateFollowStatus: (type: string) => `${getKisaanBaseURL()}/kisaan/user/associations/${type}`,

  getConnectionList: (payload) => {
    const kisanFollowUrl = `${getKisaanBaseURL()}/kisaan/user/${payload?.userId}/${payload?.realmId}/follow/stats`;
    const queryParams = `?offset=${payload?.offset}&count=${payload?.count}&type=${payload?.type}`;
    const targetUserIdParam = payload?.targetUserId ? `&targetUserId=${payload?.targetUserId}` : '';

    return `${kisanFollowUrl}${queryParams}${targetUserIdParam}`;
  },

  getAnimalsList: () => `${getKisaanBaseURL()}/kisaan/crop/p/registry-list?name=AnimalHusbandry`,
  ipAddressApi: () => `${getEventsBaseURL()}/v1/ip/location`,
  getVideoDetailES: (isAdaptive: boolean = false) =>
    `${getKisaanBaseURL()}/kisaan/search/p/videos?adaptive=${isAdaptive}`,
  getVideoSeoUrl: () => `${getKisaanBaseURL()}/kisaan/video-conversion/p/seo-friendly-url`,
  getLiveStreamAuth: () => `${getStreamURI()}/plugins/livechat/12.0.2/router/api/auth`,
  getRecommendedProducts: (videoId,type) => `${getWorkflowV2URI()}/kisaan/products/p/aac/${type}/${videoId}`,
  autoLogin: () => `${getIamURI()}/api/v2/auth/signin/code`,
  getTrendingVideos: () => `${getKisaanBaseURL()}/kisaan/global/p/trending/videos`,
  getCourseRefershUrl: (payload) => `${getWorkflowV2URI()}/kisaan/products/p/course/thinkific/${payload.courseId}/ssoUrl?buyerName=${payload.buyerName}&buyerId=${payload.buyerId}`,
  getCategory: () => `${getKisaanBaseURL()}/kisaan/categories/p/categories`,
  getCategoryVideo:()=>`${getKisaanBaseURL()}/kisaan/categories/p/videos`,
  getNewsList: () =>
    `${getWorkflowV2URI()}/ng-news/p/feeds/hashtag-timeline/KISAN`,
  getRewardsCoins: () =>
    `${getKisaanBaseURL()}/kisaan/coin/user/balance`,
  getRewardsRedeem: () =>
  `${getKisaanBaseURL()}/kisaan/coin/redeem`,
};
export default paths;
